
import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from '@/utils/toast';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireRole?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireAdmin = false,
  requireRole
}) => {
  const { user, loading, isAdmin, userRole } = useAuth();
  const location = useLocation();

  useEffect(() => {
    console.log("ProtectedRoute state:", { 
      path: location.pathname,
      user: !!user, 
      isAdmin, 
      userRole,
      requireAdmin,
      requireRole,
      loading
    });
  }, [user, isAdmin, userRole, requireAdmin, requireRole, loading, location.pathname]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && !isAdmin) {
    toast.error("Você não tem permissão para acessar esta página");
    return <Navigate to="/" replace />;
  }

  if (requireRole && requireRole.length > 0) {
    const hasRole = userRole && requireRole.includes(userRole);
    // Also allow admin access to role-protected routes
    if (!hasRole && !isAdmin) {
      toast.error("Você não tem permissão para acessar esta página");
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
